import { useQuery } from '@tanstack/react-query';
import { getCollaborationMetrics } from '@/services/composer-dashboard/get-collaboration-metrics';
import { CollaborationMetricsResponse } from '@/types/composer-dashboard';
import { useOrgStore } from '@/stores/org-store';

export const useGetCollaborationMetrics = () => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<CollaborationMetricsResponse, Error>({
    queryKey: ['composer-collaboration-metrics', orgId],
    queryFn: () => getCollaborationMetrics(orgId!),
    enabled: !!orgId,
    retry: 1,
    staleTime: 60000,
  });
};
